export default __webpack_public_path__ + "static/fsc-d73701e6ac68e2a34b25a9aa53b221a6.png";